// extracted by mini-css-extract-plugin
export default {"bill":"BillPayment_bill__BmgZA","bill1":"BillPayment_bill1__V5vqE","bill2":"BillPayment_bill2__NOzXo","bill3":"BillPayment_bill3__eM5Su"};